import type { Api } from "../types";

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

// Офлайн-заглушка геоаналитики: реальные срезы (ГДЕ продавцы vs КУДА заказы)
// приходят с бэкенда (GET /admin/analytics/geo-flows).
export const analytics: Api["analytics"] = {
	async geoFlows() {
		await sleep(150);
		return { origins: [], destinations: [], flows: [], buyers: [], destinationRegions: [], destinationDistricts: [] };
	},
	// Офлайн: Метрика не подключена - блок показывает, что задать.
	async metrika(days) {
		await sleep(150);
		const end = new Date().toISOString().slice(0, 10);
		const start = new Date(Date.now() - (days - 1) * 86_400_000).toISOString().slice(0, 10);
		return {
			status: "no_counter",
			counterId: null,
			periodStart: start,
			periodEnd: end,
			visits: 0,
			users: 0,
			pageviews: 0,
			bounceRate: 0,
			sources: [],
			goals: [],
			missingGoals: [],
			ecommerce: null,
			fetchedAt: null,
		};
	},
	async ensureMetrikaGoals() {
		await sleep(150);
		return { created: [], existing: [] };
	},
};
